import axios from 'axios';
import { getAccessToken } from './auth-guard';
//Request Interceptor
axios.interceptors.request.use(
  (config) => {
    const token = getAccessToken();
    if (token) {
      config.headers['x-auth-token'] = token;
    }
    config.headers['Content-Type'] = 'application/json';
    config.baseURL = `${process.env.REACT_APP_BASE_API}`;
    return config;
  },
  (error) => {
    console.log(error);
    Promise.reject(error);
  }
);

//Response Interceptor
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  function (error) {
    return Promise.reject(error?.response?.data);
  }
);
